import uuid from '../utils/uuid';
import { createMigration } from './utils';

export const migrationTo9_180 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('sceneGroups').forEach((sceneGroup, i) => {
                map.setIn(['sceneGroups', i], this.migrateSceneGroup(sceneGroup));
            });
        });
    },
    migrateSceneGroup(sceneGroup) {
        return sceneGroup.withMutations(map => {
            const mediaAsset = map.get('mediaAsset');
            if (!mediaAsset) {
                return;
            }
            map.setIn(['mediaAsset', 'id'], uuid());
        });
    },
});
